import { Component, OnInit, Optional, Inject } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DentalService } from 'src/app/_service/dental.service';
import { LeadsService } from 'src/app/_service/leads.service';
declare var $: any;

@Component({
  selector: 'app-scan-book-case-history',
  templateUrl: './scan-book-case-history.component.html',
  styleUrls: ['./scan-book-case-history.component.css']
})
export class ScanBookCaseHistoryComponent implements OnInit {
  myrole:string; isCMAccess:string; scanBookCaseHistoryForm: FormGroup; submitted = false; loading: boolean = false; scanId: any = ''; scanProUser = []; dataLoaded: boolean = false; bds = []; chifComplaintTestBoxData = []; showOtherChifComplaint: boolean = false; ClinicalConditionTestBoxData = []; showClinicalCondition: boolean = false; invalidChifComplaint: boolean = false; invalidClinicalCondition: boolean = false;

  constructor(public dialogRef: MatDialogRef<ScanBookCaseHistoryComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private sharedapi: SharedService, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private dentalapi: DentalService, private leadapi: LeadsService) {
    dialogRef.disableClose = true;
    this.scanId = data.scanId;
    this.scanBookCaseHistoryForm = this.formBuilder.group({
      'scanId': [null, Validators.required],
      'patient_name': [null, Validators.required],
      'patient_age': [null, Validators.required],
      'gender': [null, Validators.required],
      'scan_dentist_id': [null],
      'case_history_submission_date': [null, Validators.required],
      'type_of_patient': [null, Validators.required],
      'no_of_days': [null],
      'chif_complaint': [null, Validators.required],
      'other_chif_complaint': [null],
      'specific_note': [null],
      'clinical_condition': [null, Validators.required],
      'other_clinical_condition': [null],
      'arches_treated': [null, Validators.required],
      'clinical_finding': [null]
    });
  }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.isCMAccess = localStorage.getItem('CMAccess');

    this.getproUsers();
    this.patchScanBookCaseHistoryData();
  }

  get f() { return this.scanBookCaseHistoryForm.controls; }

  CloseModal(): void {
    this.dialogRef.close();
  }

  async saveScanBookCaseHistory() {
    this.submitted = true;
    this.loading = true;

    //  validation if chif_complaint field array value 0
    if (this.scanBookCaseHistoryForm.controls['chif_complaint'].value.length > 0) {
      var checkChifcomplaintvalid = this.scanBookCaseHistoryForm.controls['chif_complaint'].value;
      if (checkChifcomplaintvalid[0] == 0) {
        this.loading = false;
        this.invalidChifComplaint = true;
        return;
      }
    } else {
      this.invalidChifComplaint = false;
    }
    //  validation if clinical_condition field array value 0
    if (this.scanBookCaseHistoryForm.controls['clinical_condition'].value.length > 0) {
      var checkClinicalConditionvalid = this.scanBookCaseHistoryForm.controls['clinical_condition'].value;
      if (checkClinicalConditionvalid[0] == 0) {
        this.loading = false;
        this.invalidClinicalCondition = true;
        return;
      }
    } else {
      this.invalidClinicalCondition = false;
    }
    //  validation if type_of_patient seclect Overseas field
    if (this.scanBookCaseHistoryForm.controls['type_of_patient'].value == 2) {
      this.scanBookCaseHistoryForm.controls['no_of_days'].setValidators(Validators.required);
      this.scanBookCaseHistoryForm.controls['no_of_days'].updateValueAndValidity();
    } else {
      this.scanBookCaseHistoryForm.controls['no_of_days'].clearValidators();
      this.scanBookCaseHistoryForm.controls['no_of_days'].updateValueAndValidity();
    }
    //  validation if chif_complaint seclect others field
    if (this.scanBookCaseHistoryForm.controls['chif_complaint'].value.length > 0) {
      var chif_complaint_inside_other_value = this.scanBookCaseHistoryForm.controls['chif_complaint'].value;
      for (var i = 0; i < chif_complaint_inside_other_value.length; i++) {
        if (chif_complaint_inside_other_value[i] == 3) {
          this.scanBookCaseHistoryForm.controls['other_chif_complaint'].setValidators(Validators.required);
          this.scanBookCaseHistoryForm.controls['other_chif_complaint'].updateValueAndValidity();
        }
      }
    }
    //  validation if clinical_condition seclect others field
    if (this.scanBookCaseHistoryForm.controls['clinical_condition'].value.length > 0) {
      var clinical_condition_inside_other_value = this.scanBookCaseHistoryForm.controls['clinical_condition'].value;
      for (var i = 0; i < clinical_condition_inside_other_value.length; i++) {
        if (clinical_condition_inside_other_value[i] == 13) {
          this.scanBookCaseHistoryForm.controls['other_clinical_condition'].setValidators(Validators.required);
          this.scanBookCaseHistoryForm.controls['other_clinical_condition'].updateValueAndValidity();
        }
      }
    }

    if (this.scanBookCaseHistoryForm.invalid) {
      this.loading = false;
      return;
    }
    this.scanBookCaseHistoryForm.value.scanId = parseInt(this.scanId);
    await this.dentalapi.saveScanBookCaseHistoryData(this.scanBookCaseHistoryForm.value)
      .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.sharedapi.presentToast(data.msg);
          this.patchScanBookCaseHistoryData();
        }
        else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
  }

  async patchScanBookCaseHistoryData() {
    this.dataLoaded = false;
    this.dentalapi.getScanBookCaseHistoryData(this.scanId).subscribe((response: any) => {
      if (response.status) {
        this.dataLoaded = true;
        if (response.data.chief_complaints) {
          this.patchShowChifComplaintTestBox(response.data.chief_complaints);
        }
        if (response.data.clinical_conditions) {
          this.patchshowClinicalConditionTestBox(response.data.clinical_conditions);
        }
        this.scanBookCaseHistoryForm.patchValue({
          'scanId': this.scanId,
          'patient_name': response.data.lead_name,
          'patient_age': response.data.patient_age,
          'gender': response.data.gender,
          'scan_dentist_id': response.data.case_history_pro_id,
          'case_history_submission_date': response.data.case_history_submission_date,
          'type_of_patient': response.data.type_of_patient,
          'no_of_days': response.data.no_of_days,
          'chif_complaint': response.data.chief_complaints,
          'other_chif_complaint': response.data.chief_complaints_others_text,
          'specific_note': response.data.goals_special_notes,
          'clinical_condition': response.data.clinical_conditions,
          'other_clinical_condition': response.data.clinical_conditions_others_text,
          'arches_treated': response.data.arches_to_be_treated,
          'clinical_finding': response.data.clinical_finding,
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getproUsers() {
    this.leadapi.getDentalProUsers().subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  showChifComplaintTestBox(ob) {
    this.chifComplaintTestBoxData = ob.value;
    if (this.chifComplaintTestBoxData.length > 0) {
      for (var i = 0; i < this.chifComplaintTestBoxData.length; i++) {
        if (this.chifComplaintTestBoxData[i] == 3) {
          this.showOtherChifComplaint = true;
        } else {
          this.showOtherChifComplaint = false;
          this.scanBookCaseHistoryForm.controls['other_chif_complaint'].clearValidators();
          this.scanBookCaseHistoryForm.controls['other_chif_complaint'].updateValueAndValidity();
        }
      }
    } else {
      this.showOtherChifComplaint = false;
    }
  }

  patchShowChifComplaintTestBox(ob) {
    this.chifComplaintTestBoxData = ob;
    if (this.chifComplaintTestBoxData.length > 0) {
      for (var i = 0; i < this.chifComplaintTestBoxData.length; i++) {
        if (this.chifComplaintTestBoxData[i] == 3) {
          this.showOtherChifComplaint = true;
        } else {
          this.showOtherChifComplaint = false;
        }
      }
    } else {
      this.showOtherChifComplaint = false;
    }
  }

  showClinicalConditionTestBox(ob) {
    this.ClinicalConditionTestBoxData = ob.value;
    if (this.ClinicalConditionTestBoxData.length > 0) {
      for (var i = 0; i < this.ClinicalConditionTestBoxData.length; i++) {
        if (this.ClinicalConditionTestBoxData[i] == 13) {
          this.showClinicalCondition = true;
        } else {
          this.showClinicalCondition = false;
          this.scanBookCaseHistoryForm.controls['other_clinical_condition'].clearValidators();
          this.scanBookCaseHistoryForm.controls['other_clinical_condition'].updateValueAndValidity();
        }
      }
    } else {
      this.showClinicalCondition = false;
    }
  }

  patchshowClinicalConditionTestBox(ob) {
    this.ClinicalConditionTestBoxData = ob;
    if (this.ClinicalConditionTestBoxData.length > 0) {
      for (var i = 0; i < this.ClinicalConditionTestBoxData.length; i++) {
        if (this.ClinicalConditionTestBoxData[i] == 13) {
          this.showClinicalCondition = true;
        } else {
          this.showClinicalCondition = false;
        }
      }
    } else {
      this.showClinicalCondition = false;
    }
  }


}
